import * as React from 'react';
import { useT } from '../helpers/i18n';

import ContactForm from './contact/ContactForm';
import ContactLocations from './contact/ContactLocations';
import ContactSkeleton from './Skeletons/ContactSkeleton';
import ViewPort from './ViewPort';
import {Alert} from "@mui/lab";
import Checkers from '../helpers/class/Checkers';
import RawEmbedHtml from './RawEmbedHtml';

export default function Contact ( props ) {
  const t = useT();

  const isSuccess = props.isSuccess != undefined ? props.isSuccess : false

  const showContactForm = props.showContactForm != undefined ? props.showContactForm : true

  const contactPhoneOverride = props.contactPhoneOverride != undefined ? props.contactPhoneOverride : null

  const contactEmailOverride = props.contactEmailOverride != undefined ? props.contactEmailOverride : null

  const contactTitleOverride = props.contactTitleOverride != undefined ? props.contactTitleOverride : null

  const contactPhone = props.hasOwnProperty('contactHtml') && props.contactHtml?.hasOwnProperty('contact_phone') && props.contactHtml.contact_phone != null ? props.contactHtml.contact_phone : null

  const contactEmail = props.hasOwnProperty('contactHtml') && props.contactHtml?.hasOwnProperty('contact_email') && props.contactHtml.contact_email != null ? props.contactHtml.contact_email : null

  const contactOver = props.hasOwnProperty('contactHtml') && props.contactHtml?.hasOwnProperty('contact_over') && props.contactHtml.contact_over != null ? props.contactHtml.contact_over : null

  return (
    <>
      {
        props.showContactSection ?
          <section id={'contact'} className="bg-master-lightest py-5">
            <ViewPort
              parentClassName={'container-fluid mb-5'}
              skeletonItem={ <ContactSkeleton showContactForm={props.showContactForm}/> }
            >
                <div className="container">
                  <div className="row">
                    <ContactLocations
                        contactOver={contactOver}
                      locations={props.locations}
                      showContactForm={showContactForm}
                      contactFormTitle={props.contactFormTitle}
                      contactPhoneOverride={contactPhoneOverride}
                      contactEmailOverride={contactEmailOverride}
                      contactTitleOverride={contactTitleOverride}
                      contactPhone={contactPhone}
                      contactEmail={contactEmail}
                      isManager={props.isManager}
                      managerContact={props.managerContact}
                      propertyLat={props.propertyLat}
                      propertyLng={props.propertyLng}
                      socialLinks={props.socialLinks}
                      propertyBadges={props.propertyBadges}
                      contactEmails={props.contactEmails}
                    />
                    {
                      isSuccess ?
                          <>
                            <div className={"col-12 col-sm-12 col-md-6 ps-md-5"}>
                              <Alert severity="success" sx={{mb: "20px"}}>
                                {t('contact.thanks')}
                                <br />
                                {t('contact.received')}
                              </Alert>
                            </div>
                          </>
                          :
                          <>
                        {
                          props.showContactForm ?
                            <ContactForm
                              captchaSiteKey={props.captchaSiteKey}
                              showDestination={props.showDestination}
                              searchbarRadius={props.searchbarRadius}
                              insideSingleProperty={false} 
                              />
                            : ''
                        }
                          </>
                    }
                    {
                      props.contactHtml != undefined ?
                        <div dangerouslySetInnerHTML={{ __html: props.contactHtml.contact_html }}/>
                        :
                        ""
                    }
                  </div>
                  {
                        !props.isManager && Checkers.isValidArray(props.propertyBadges) &&
                          <div className="row mt-5 image-badges">
                            <style>{'.image-badges ul, .image-badges li { list-style: none; padding: 0; margin: 0; }'}</style>
                            {
                              props.propertyBadges.map((badge) => (
                                  <RawEmbedHtml className="col-4 col-md-2  mb-4" key={badge.id} html={badge.badgeCode} hideIfImageFails />
                              ))
                            }
                          </div>
                  }
                </div>
                {/* Social links moved to the site footer - see SocialLinks.tsx. */}
            </ViewPort>
          </section>
          : <></>
      }
    </>
  )
}
